import * as API from "../../api";
import * as ActionTypes from "../action-types";

import {
    setLoadingVehicleEvent,
    unsetLoadingVehicleEvent
} from './style'

import { message } from 'antd'

export const get_vehicle_log_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return Promise.allSettled([
        API.getVehicleLogByTimeFrameSync(vid, startTime, endTime),
        API.getMDVRLogByTimeFrameSync(vid, startTime, endTime)
    ])
    .then(([vehicleInfo, mdvrInfo]) => {
        try {
            const { vehicleLogs = [], status: statusVehicleInfo, msg: msgVehicleInfo } = vehicleInfo.value || {}
            const { mdvrLogs = [], status: statusMDVRInfo, msg: msgMDVRInfo } = mdvrInfo.value || {}

            const vehicleMDVRLogs = [ ...vehicleLogs, ...mdvrLogs ]

            if((statusVehicleInfo === 200) && (statusMDVRInfo === 200)) {
                vehicleMDVRLogs && vehicleMDVRLogs.length && dispatch(get_vehicle_log_by_timeframe_success(vehicleMDVRLogs, vid, startTime, endTime))
            } else {
                if(statusMDVRInfo !== 200) message.error(msgMDVRInfo)
                if(statusVehicleInfo !== 200) message.error(msgVehicleInfo)
            }

        } catch(err) {
            message.error('Error in getting timeframe vehicle logs. Refresh page?')
        }
    })

    // return API
    // .getVehicleLogByTimeFrameSync(vid, startTime, endTime) 
    // .then(info => {
        
    //     try {
    //         const {
    //             vehicleLogs
    //         } = info

    //         vehicleLogs && vehicleLogs.length && dispatch(get_vehicle_log_by_timeframe_success(vehicleLogs, vid, startTime, endTime))

    //     } catch(err) {
    //         message.error('Error in getting timeframe vehicle logs. Refresh page?')
    //     }
    // })
    
}

const get_vehicle_log_by_timeframe_success = (vehicleLogs, vid, startTime, endTime) => {
    return {
        type: ActionTypes.GET_TIMEFRAME_VEHICLE_LOGS,
        vehicleLogs,
        vid, startTime, endTime
    }
}

export const set_selected_vehicle_for_vehicle_log_request = (vid) => dispatch => {
    dispatch(set_selected_vehicle_for_vehicle_log_success(vid))
}

const set_selected_vehicle_for_vehicle_log_success = (vid) => {
    return {
        type: ActionTypes.SET_SELECTED_VEHICLE_FOR_VEHICLE_LOG,
        vid
    }
}

export const clear_selected_vehicle_for_vehicle_log_request = () => dispatch => {
    dispatch(clear_selected_vehicle_for_vehicle_log_success())
}

const clear_selected_vehicle_for_vehicle_log_success = () => {
    return {
        type: ActionTypes.UNSET_SELECTED_VEHICLE_FOR_VEHICLE_LOG
    }
}

export const clear_event_vehicle_log_request = () => dispatch => {
    dispatch(clear_event_vehicle_log_success())
}

const clear_event_vehicle_log_success = () => {
    return {
        type: ActionTypes.CLEAR_TIMEFRAME_VEHICLE_EVENT_LOGS
    }
}



export const set_selected_vehicle_log_time_request = (vehicleTime) => dispatch => {
    dispatch(set_selected_vehicle_log_time_success(vehicleTime))
}

const set_selected_vehicle_log_time_success = (vehicleTime) => {
    return {
        type: ActionTypes.SET_SELECTED_VEHICLE_LOG_TIME,
        vehicleTime
    }
}

export const get_vehicle_derivative_log_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return API
    .getVehicleDerivativeLogByTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                vehicleDerivativeLogs
            } = info

            vehicleDerivativeLogs && vehicleDerivativeLogs.length && dispatch(get_vehicle_derivative_log_by_timeframe_success(vehicleDerivativeLogs, vid, startTime, endTime))


        } catch(err) {
            message.error('Error in getting timeframe vehicle logs. Refresh page?')
        }
    })
    
}

const get_vehicle_derivative_log_by_timeframe_success = (vehicleDerivativeLogs, vid, startTime, endTime) => {
    return {
        type: ActionTypes.GET_TIMEFRAME_VEHICLE_DERIVATIVE_LOGS,
        vehicleDerivativeLogs,
        vid, startTime, endTime
    }
}

export const get_vehicle_event_log_by_timeframe_request = (vid, startTime, endTime, cb = () => {}) => dispatch => {

    dispatch(setLoadingVehicleEvent())

    return API
    .getVehicleEventLogByTimeFrameSync(vid, startTime, endTime) 
    .then(info => {
        
        try {
            const {
                vehicleEventLogs,
                msg,
                status
            } = info

            if(status === 200) {
                vehicleEventLogs && vehicleEventLogs.length && dispatch(get_vehicle_event_log_by_timeframe_success(vehicleEventLogs, vid, startTime, endTime))
                cb(vehicleEventLogs)

                            // console.log(vehicleEventLogs.filter(vel => vel.eventid.includes('cms#')).length)
    
                // if(!vehicleEventLogs?.length) {
                //     message.error('No data available!')
                // }
            } else {
                message.error(msg)
            }

        } catch(err) {
            message.error('Error in getting timeframe vehicle logs. Refresh page?')
        }
    })
    .finally(() => {
        dispatch(unsetLoadingVehicleEvent())
    })
    
}

export const get_vehicle_event_logs_by_timeframe_request = () => dispatch => {

    return API
    .getVehicleEventLogsByTimeFrameSync() 
    .then(info => {

        try {
            const {
                vehicleEventLogs
            } = info

            vehicleEventLogs && vehicleEventLogs.length && dispatch(get_vehicle_event_log_by_timeframe_success(vehicleEventLogs))


        } catch(err) {
            message.error('Error in getting timeframe vehicle logs. Refresh page?')
        }
    })
    
}

const get_vehicle_event_log_by_timeframe_success = (vehicleEventLogs, vid, startTime, endTime) => {
    return {
        type: ActionTypes.GET_TIMEFRAME_VEHICLE_EVENT_LOGS,
        vehicleEventLogs,
        vid, startTime, endTime
    }
}

export const clear_vehicle_event_log_request = () => dispatch => {
    dispatch(clear_vehicle_event_log_success())
}

const clear_vehicle_event_log_success = () => {
    return {
        type: ActionTypes.CLEAR_VEHICLE_EVENT_LOG
    }
}


export const get_vehicle_geo_state_log_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return API
    .getVehicleGeoStateLogByTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                vehicleGeoStateLogs
            } = info

            vehicleGeoStateLogs && vehicleGeoStateLogs.length && dispatch(get_vehicle_geo_state_log_by_timeframe_success(vehicleGeoStateLogs, vid, startTime, endTime))

        } catch(err) {
            console.log(err)
            message.error('Error in getting timeframe vehicle geo logs. Refresh page?')
        }
    })
    
}

const get_vehicle_geo_state_log_by_timeframe_success = (vehicleGeoStateLogs, vid, startTime, endTime) => {
    return {
        type: ActionTypes.GET_TIMEFRAME_VEHICLE_GEO_STATE_LOGS,
        vehicleGeoStateLogs,
        vid, startTime, endTime
    }
}

export const get_vehicle_ecu_log_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return API
    .getVehicleECULogByTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                vehicleECULogs
            } = info

            vehicleECULogs && vehicleECULogs.length && dispatch(get_vehicle_ecu_log_by_timeframe_success(vehicleECULogs, vid, startTime, endTime))


        } catch(err) {
            console.log(err)
            message.error('Error in getting timeframe vehicle geo logs. Refresh page?')
        }
    })
    
}

const get_vehicle_ecu_log_by_timeframe_success = (vehicleECULogs, vid, startTime, endTime) => {
    return {
        type: ActionTypes.GET_TIMEFRAME_VEHICLE_ECU_LOGS,
        vehicleECULogs,
        vid, startTime, endTime
    }
}

export const set_selected_event_log_data = (data) => {
    return {
        type: ActionTypes.SET_SELECTED_EVENT_LOG_VID,
        data
    }
}

export const unset_selected_event_log_data = () => {
    return {
        type: ActionTypes.UNSET_SELECTED_EVENT_LOG_VID
    }
}

export const update_event_log_info_request = (items, cb = () => {}) => dispatch => {
    dispatch(setLoadingVehicleEvent())

    API
    .updateVehicleEventLogInfo(
        items
    )
    .then(info => {
        const { status, msg, eventLog, vehicleEventLog } = info

        if(status === 200) {
            dispatch(update_event_log_info_success(eventLog || vehicleEventLog))
            message.success(msg)
            cb()
        }
        else {
            message.warning('Failed in Updating Event Log. Retry? error: ' + msg)
        }
    })
    .finally(() => {
        dispatch(unsetLoadingVehicleEvent())
    })
}

const update_event_log_info_success = (eventLog) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_EVENT_LOG,
        eventLog
    }
}